// extracted by mini-css-extract-plugin
module.exports = {"smarter":"Smarter_smarter__d2HAm"};